// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.teacher-quick-view[data-v-96b25ea2] {\n    max-width: 320px;\n}\n.cursor-pointer[data-v-96b25ea2] {\n    cursor: pointer;\n}\n.v-list-item[data-v-96b25ea2] {\n    min-height: 36px !important;\n}\n.v-list-item[data-v-96b25ea2]:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n    cursor: pointer;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
